/**
 * External Dependencies
 */
import 'jquery';
import AOS from 'aos';

//import './modules/navigation'
//import './modules/google-maps'
AOS.init()

let cache = {}
require.context('./modules', true, /\.js$/)

//load all js modules
function importAll(r) {
  r.keys().forEach(key => cache[key] = r(key))
}

importAll(require.context('./modules', true, /\.js$/))


